import Column from 'layout/Components/Column'
import { useState } from 'react'
import styled from 'styled-components'
import { ModalProps } from 'UIKit/Modal'
import { PaymentPageEnums } from '../Menu'
import { PAYMENT_MODAL_THEME, StylePaymentModal } from '../MobilePayment/components/styles'
import useCommitmentVisibility from '../MobilePayment/hooks/useCommitmentVisibility'
import { IPaymentProps } from '../MobilePayment/types'
import { PaymentMenuDesktop } from './components/PaymentMenu'
import Deposit from './Deposit'
import Swap from './Swap'
import Tip from './Tip'
import Withdraw from './Withdraw'

const DesktopPaymentModal: React.FC<ModalProps<IPaymentProps>> = ({
  data: { defaultPage, pageData, initialToken },
  onDismiss,
}) => {
  const [paymentPage, setPaymentPage] = useState<PaymentPageEnums>(defaultPage)
  const commitmentsControl = useCommitmentVisibility(paymentPage)

  return (
    <StyledDesktopPaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <PaymentMenuDesktop
        paymentPage={paymentPage}
        onPaymentPageChanged={setPaymentPage}
        colorTheme={PAYMENT_MODAL_THEME}
      />
      <Column height="100%" width="calc(100% - 200px)" pb={paymentPage === PaymentPageEnums.Tip ? '0' : '24px'}>
        {paymentPage === PaymentPageEnums.Deposit && (
          <Deposit commitmentsControl={commitmentsControl} onDismiss={onDismiss} onRedirect={setPaymentPage} />
        )}
        {paymentPage === PaymentPageEnums.Withdraw && <Withdraw onDismiss={onDismiss} onRedirect={setPaymentPage} />}
        {paymentPage === PaymentPageEnums.Tip && (
          <Tip userName={pageData?.tipUserName || ''} onDismiss={onDismiss} initialToken={initialToken} />
        )}
        {paymentPage === PaymentPageEnums.Swap && <Swap onDismiss={onDismiss} />}
      </Column>
    </StyledDesktopPaymentModal>
  )
}

const StyledDesktopPaymentModal = styled(StylePaymentModal)`
  flex-direction: row;
  box-sizing: border-box;
  padding: 0;
  max-width: 600px;
  min-width: 600px;

  border-radius: ${({ theme }) => theme.radii.large};
  height: max(80%, min(760px, calc(100% - 40px)));

  .wrap-header-container {
    padding: 20px;
  }
  .wrap-body-container {
    padding: 0 20px;
    overflow-y: scroll;
    scrollbar-width: none;
  }
`

export default DesktopPaymentModal
